import Vue from 'vue'
import Router from 'vue-router'
import AffiliateLogin from '@/views/AffiliateLogin.vue'
import AffiliateDashboard from '@/views/AffiliateDashboard.vue'
// import AffiliateSignup from '@/views/AffiliateSignup.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', name: 'AffiliateLogin', component: AffiliateLogin },
    // { path: '/signup', name: 'AffiliateSignup', component: AffiliateSignup },
    { path: '/dashboard', name: 'AffiliateDashboard', component: AffiliateDashboard }
  ]
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('affiliate_token')
  const publicPaths = ['/login']
  const isPublic = publicPaths.includes(to.path)
  if (!token && !isPublic) {
    return next('/login')
  }
  if (token && isPublic) {
    return next('/dashboard')
  }
  return next()
})

export default router
